<template>
    <div :class="`arrow-${side}`" @click="changePage(side)">
        <!-- <img :src="img" alt="" v-if="statusArrow(side)">
        <img :src="imgActive" alt="" v-else> -->
        <Arrow class="arrow-svg" v-if="statusArrow(side)" :fill="colors.theme == 'dark' ? '#fff' : '#000'"></Arrow>
        <Arrow v-else class="arrow-svg" fill="#3c464e"></Arrow>
    </div>
</template>
<script>
import Arrow from "../Shared/CustomIcons/Report/Arrow"
export default {
    components:{Arrow},
    props:{
        index : {
            type : Number,
            required : true
        },
        maxIndex : {
            type : Number,
            required : true
        },
        side : {
            type : String,
            required : true
        }
    },
    data(){
        return{
            img : require(`../../assets/report_arrow_${this.side}_active.png`),
            imgActive : require(`../../assets/report_arrow_${this.side}.png`),
            colors:{}
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem('colors'))
    },
    methods: {
        statusArrow(mode){
            let index = this.index + 1
            let maxIndex = this.maxIndex 
            if(mode == 'right'){
                return index == maxIndex ? false : true
            }
            return index == 1 ? false : true
        },
        async changePage(mode){
            let enable = await this.statusArrow(mode)
            if(!enable){
                return
            }
            if(mode == 'right'){
                this.$emit('newIndex', this.index + 1 )
                return
            }
            this.$emit('newIndex', this.index - 1 )
        }
    }
}
</script>
<style lang="scss" scoped>
    .arrow-left, .arrow-right{
        position: absolute ;
        top: calc(50% - 15px);
        svg{
            height: 30px;
        }
    }
    .arrow-left{
        transform: rotate(180deg);
        left: 10px;
    }
    .arrow-right{

        right: 10px;
    }
</style>
